import {
  RESET_CALCULATOR_ROUNDING,
  RESET_CALCULATOR_ROUNDING_PUBLIC_RESPONSE,
  RESET_CALCULATOR_ROUNDING_RESPONSE,
} from 'constants';
import {
  SET_CALCULATOR_ROUNDING,
  SET_CALULATOR_ROUNDING_PUBLIC_RESPONSE,
  SET_CALULATOR_ROUNDING_RESPONSE,
} from 'store/action';
import useStore from '../../../hooks/useStore';

const useCalculatorRoundingStore = () => {
  const { state, setState, dispatch } = useStore();

  const {
    calculatorRounding,
    calculatorRoundingResponse,
    calculatorRoundingPublicResponse,
  } = state || {};

  const {
    isSendAmountRounding,
    isGetAmountRounding,
    isRateFetching,
    roundingFieldName,
  } = calculatorRounding || {};
  const isCalculatorRounding =
    isSendAmountRounding || isGetAmountRounding || isRateFetching;

  const setSendAmountRounding = (isSendAmountRounding = false) =>
    setState({
      action: SET_CALCULATOR_ROUNDING,
      payload: {
        ...calculatorRounding,
        isSendAmountRounding,
      },
    });

  const setGetAmountRounding = (isGetAmountRounding = false) =>
    setState({
      action: SET_CALCULATOR_ROUNDING,
      payload: {
        ...calculatorRounding,
        isGetAmountRounding,
      },
    });

  const setRateFetching = (isRateFetching = false) =>
    setState({
      action: SET_CALCULATOR_ROUNDING,
      payload: {
        ...calculatorRounding,
        isRateFetching,
      },
    });

  const setCalculatorRounding = (calculatorRoundingPayload = {}) =>
    setState({
      action: SET_CALCULATOR_ROUNDING,
      payload: {
        ...calculatorRounding,
        ...calculatorRoundingPayload,
      },
    });

  const resetCalculatorRounding = () =>
    setState({
      action: SET_CALCULATOR_ROUNDING,
      payload: RESET_CALCULATOR_ROUNDING,
    });

  const setCalculatorRoundingResponse = (
    calculatorRoundingResponse = RESET_CALCULATOR_ROUNDING_RESPONSE,
  ) => {
    setState({
      action: SET_CALULATOR_ROUNDING_RESPONSE,
      payload: calculatorRoundingResponse,
    });
  };

  const setCalculatorRoundingPublicResponse = (
    calculatorRoundingResponse = RESET_CALCULATOR_ROUNDING_PUBLIC_RESPONSE,
  ) => {
    setState({
      action: SET_CALULATOR_ROUNDING_PUBLIC_RESPONSE,
      payload: calculatorRoundingResponse,
    });
  };

  const setRoundingFieldName = (roundingFieldName = '') =>
    setState({
      action: SET_CALCULATOR_ROUNDING,
      payload: {
        ...calculatorRounding,
        roundingFieldName,
      },
    });

  return {
    ...state,
    setState,
    dispatch,
    calculatorRounding,
    calculatorRoundingResponse,
    calculatorRoundingPublicResponse,
    isSendAmountRounding,
    isGetAmountRounding,
    isRateFetching,
    isCalculatorRounding,
    setSendAmountRounding,
    setGetAmountRounding,
    setRateFetching,
    resetCalculatorRounding,
    setCalculatorRounding,
    setCalculatorRoundingResponse,
    setCalculatorRoundingPublicResponse,
    roundingFieldName,
    setRoundingFieldName,
  };
};

export default useCalculatorRoundingStore;
